module.exports = __webpack_public_path__ + "f58f1a7b721e1c2a30e383d0e812458c.svg";